import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { selectCleverlynkGroup } from "../../redux/slices/cleverlynkSlice";
import GeoSelector from "./GeoSelector";
import MenuSelector from "./MenuSelector";

interface IGroupSelector {}

const GroupSelector = () => {
  const cleverlynkGroup = useSelector(selectCleverlynkGroup);
  return cleverlynkGroup?.type === "GEO" ? <GeoSelector /> : <MenuSelector />;
};
export default GroupSelector;
